import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'sbnb-manage-subscription-wizard-footer',
  template: `
    <div class="flex flex-wrap w-full justify-between gap-3">
      <button
        mat-flat-button
        class="button__secondary w-full sm:max-w-fit"
        (click)="cancel.emit()"
        [disabled]="disabled">
        Cancel
      </button>
      <div class="flex flex-wrap justify-end gap-3 w-full sm:max-w-fit">
        <button
          *ngIf="!isFirstStep"
          mat-flat-button
          class="button__secondary w-full sm:max-w-fit"
          (click)="back.emit()"
          matStepperPrevious
          [disabled]="disabled">
          Back
        </button>
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageSubscriptionWizardFooterComponent implements OnInit {
  @Output() cancel = new EventEmitter();
  @Output() back = new EventEmitter();
  @Input() disabled = false;
  @Input() isFirstStep = false;

  constructor() { }

  ngOnInit(): void { }
}
